import {
  Activity as ActivityIcon,
  Codesandbox as CodesandboxIcon,
  User as UserIcon,
  MapPin as MapPinIcon,
  PieChart as PieChartIcon,
  // Briefcase as BriefcaseIcon,
  // Calendar as CalendarIcon,
  // ShoppingCart as ShoppingCartIcon,
  // Folder as FolderIcon,
  // BarChart as BarChartIcon,
  // Lock as LockIcon,
  // UserPlus as UserPlusIcon,
  // Shield as ShieldIcon,
  // AlertCircle as AlertCircleIcon,
  // Trello as TrelloIcon,
  // Layout as LayoutIcon,
  // Edit as EditIcon,
  // DollarSign as DollarSignIcon,
  // Mail as MailIcon,
  // MessageCircle as MessageCircleIcon,
  // Share2 as ShareIcon,
  // Users as UsersIcon,
  List as ListIcon,
  Rss as RssIcon
} from 'react-feather';


/* eslint-disable import/prefer-default-export */
export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};



export const custMenu = [
  {
    rolNeed: 3,
    subheader: 'customMenu.navBar.home.title',
    href: 'customMenu.navBar.home.href',
    items: [
      {
        title: 'customMenu.navBar.home.dashboardadmin.title',
        icon: PieChartIcon,
        href: 'customMenu.navBar.home.dashboardadmin.href'
      }
    ]
  },
  {
    subheader: 'customMenu.navBar.general.title',
    items: [
      {
        title: 'customMenu.navBar.general.tickets.title',
        icon: ActivityIcon,
        href: 'customMenu.navBar.general.tickets.href',
        items: [
          {
            title: 'customMenu.navBar.general.tickets.list.title',
            href: 'customMenu.navBar.general.tickets.list.href'
          },
          {
            title: 'customMenu.navBar.general.tickets.new.title',
            href: 'customMenu.navBar.general.tickets.new.href'
          }
        ]
      },
      {
        rolNeed: 4,
        title: 'customMenu.navBar.general.maps.title',
        icon: MapPinIcon,
        href: 'customMenu.navBar.general.maps.href',
        items: [
          {
            rolNeed: 4,
            title: 'customMenu.navBar.general.maps.deviceMap.title',
            href: 'customMenu.navBar.general.maps.deviceMap.href'
          },
          {
            rolNeed: 3,
            title: 'customMenu.navBar.general.maps.heatMap.title',
            href: 'customMenu.navBar.general.maps.heatMap.href'
          },
          {
            rolNeed: 3,
            title: 'customMenu.navBar.general.maps.newEvent.title',
            href: 'customMenu.navBar.general.maps.newEvent.href'
          }
        ]
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.learning.title',
        icon: CodesandboxIcon,
        href: 'customMenu.navBar.general.learning.href',
        items: [
          {
            title: 'customMenu.navBar.general.learning.videos.title',
            href: 'customMenu.navBar.general.learning.videos.href'
          }
        ]
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.newsletter.title',
        icon: RssIcon,
        href: 'customMenu.navBar.general.newsletter.href'
      }
    ]
  },
  {
    subheader: 'customMenu.navBar.management.title',
    items: [
      {
        title: 'dashboardLayout.navBar.sub_pages.account.title',
        href: 'dashboardLayout.navBar.sub_pages.account.href',
        icon: UserIcon
      },
      {
        title: 'customMenu.navBar.management.abm.title',
        icon: ListIcon,
        href: 'customMenu.navBar.management.abm.href',
        items: [
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.users.title',
            href: 'customMenu.navBar.management.abm.users.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.vehicles.title',
            href: 'customMenu.navBar.management.abm.vehicles.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.projects.title',
            href: 'customMenu.navBar.management.abm.projects.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.newsleters.title',
            href: 'customMenu.navBar.management.abm.newsleters.href'
          },
          {
            title: 'customMenu.navBar.management.abm.equipments.title',
            href: 'customMenu.navBar.management.abm.equipments.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.equipmentsTypes.title',
            href: 'customMenu.navBar.management.abm.equipmentsTypes.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.equipmentBrand.title',
            href: 'customMenu.navBar.management.abm.equipmentBrand.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.equipmentModel.title',
            href: 'customMenu.navBar.management.abm.equipmentModel.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.crashTypes.title',
            href: 'customMenu.navBar.management.abm.crashTypes.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.crashSeverity.title',
            href: 'customMenu.navBar.management.abm.crashSeverity.href'
          },
          {
            rolNeed: 1,
            title: 'customMenu.navBar.management.abm.videoFeed.title',
            href: 'customMenu.navBar.management.abm.videoFeed.href'
          }
        ]
      }
    ]
  }
];